import(/* webpackMode: "eager", webpackExports: ["message","success","error"] */ "__barrel_optimize__?names=message!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/newIndex/BlogAndFAQ.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/newIndex/CategoryDiscovery.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/newIndex/FeaturedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/newIndex/HeroBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/newIndex/ServiceBar.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/newIndex/StatsAndSolutions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/newIndex/WhyChooseUs.tsx");
